import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Flex } from 'rebass';

import Icon from './Icon';

const copyToClipboard = (text) => {
  const prevFocus = document.activeElement;
  // We can use a dummy textarea to hold our text temporarily while
  // we copy it. We use a textarea to capture line breaks.
  const textArea = document.createElement('textarea');
  document.body.appendChild(textArea);

  textArea.value = text;
  textArea.select();
  document.execCommand('copy');

  // Cleanup
  document.body.removeChild(textArea);
  prevFocus.focus();
};

const CopyToClipboard = ({ children, copyMessage, tooltipLocation, text, ...props }) => {
  const [copied, setCopied] = useState(false);

  const handleClick = () => {
    copyToClipboard(text);
    setCopied(true);

    setTimeout(() => setCopied(false), 3000);
  };

  return (
    <Flex
      alignItems="center"
      {...props}
    >
      <Flex
        as="button"
        alignItems="center"
        css={`
          // reset default browser styles for buttons
          border: none;
          background: transparent;
          padding: 0;
          cursor: pointer;
          opacity: 1;
          text-align: inherit;

          &:hover, &:focus {
            opacity: .8;
          }
        `}
        tabIndex={0}
        type="button"
        onClick={handleClick}
      >
        <Icon
          icon={copied ? 'check' : 'copy'}
          ml={children ? 2 : 0}
          color={copied ? 'var(--iconSuccess)' : 'var(--iconNeutral)'}
        />
      </Flex>
    </Flex>
  );
};

CopyToClipboard.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  copyMessage: PropTypes.string,
  tooltipLocation: PropTypes.oneOf(['bottom', 'left', 'right', 'top']),
  text: PropTypes.string.isRequired,
};

CopyToClipboard.defaultProps = {
  children: null,
  copyMessage: 'Copy',
  tooltipLocation: 'right',
};

export default CopyToClipboard;
